import React from "react"
import {makeStyles} from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import IconButton from "@material-ui/core/IconButton"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer"

/**
 * styles.
 * @type {(props?: any) => ClassNameMap<"root"|"card">}
 */
const useStyles = makeStyles((theme) => ({
	card: {
		borderRadius: "20px 20px 0 0",
		height: "max-content",
		width: "100%",
		maxWidth: 600,
		background: "#fff",
		margin: "0 auto",
		zIndex: 9999999991,
	},
	drawerContent: {
		overflow: "auto",
		padding: "1rem",
		"& > *": {
			margin: ".8rem 0",
		},
		"& button": {
			boxShadow: "unset",
		},
		"& *:focus": {
			outline: 0,
		},
		"&::-webkit-scrollbar": {
			width: "12px",
		},
		"&::-webkit-scrollbar-track": {
			backgroundColor: "#e6e6e6",
		},
		"&::-webkit-scrollbar-thumb": {
			backgroundColor: "rgba(0,0,0,.1)",
			borderRadius: "0.5rem",
		},
	},
	title: {
		margin: "auto 0",
	},
}))
const SlideCard = (props) => {
	const classes = useStyles()
	return (
		<SwipeableDrawer
			classes={{paper: classes.card}}
			className={classes.scrollBar}
			anchor={"bottom"}
			open={props.show}
			onClose={props.close}>
			<Grid container className={classes.drawerContent}>
				<Grid container justifyContent={"space-between"}>
					<Grid item className={classes.title}>
						<Typography variant={"h6"}>{props.title}</Typography>
					</Grid>
					<Grid item>
						<IconButton onClick={props.close}>
							<HighlightOffIcon />
						</IconButton>
					</Grid>
				</Grid>
				{props.children}
			</Grid>
		</SwipeableDrawer>
	)
}

export default SlideCard
